import { Button } from 'components/buttons/Button/Button';
import './styles.scss';

const ProductCatalogBox = ({ title, image, text }) => {
    return (
        <div className="box product-box">
            <h3>{title}</h3>
            <div className="product-catalog">
                <img src={image} alt="wuxal catalog" />
                <p className="body1 product-catalog__text">{text}</p>
                <div className="product-catalog__buttons">
                    <Button type="button-eye">VIEW CATALOG</Button>
                    <Button type="download-button">DOWNLOAD</Button>
                </div>
            </div>
        </div>
    );
};

export default ProductCatalogBox;
